import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filter: {
    country: null,
    examboard: null,
    subject: null,
    grade: null,
    chapter: null,
  },
  formData: null,
};

export const selftestsSlice = createSlice({
  name: "selftest",
  initialState,
  reducers: {
    setFilter: (state, action) => {
      state.filter = action.payload;
    },
    setFormData: (state, action) => {
      state.formData = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setFilter, setFormData } = selftestsSlice.actions;

export default selftestsSlice.reducer;
